import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonUtilityLib } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { Subscription, filter } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetViewComponent } from '../asset-info/components/asset-view/asset-view.component';
import { AssetUsageRightMetadataComponent } from './asset-usage-right-metadata/asset-usage-right-metadata.component';

@Component({
  selector: 'thehubz-asset-usage-rights',
  templateUrl: './asset-usage-rights.component.html',
  styleUrls: ['./asset-usage-rights.component.scss'],
  standalone: true,
  imports: [CommonModule, AssetViewComponent, AssetUsageRightMetadataComponent],
})
export class AssetUsageRightsComponent implements OnInit, OnDestroy {
  assetInfo!: AnyType;
  assetDataSubjectSubscription: Subscription | undefined;
  constructor(private assetCommonService: AssetCommonService, private commonUtilityLib: CommonUtilityLib) {}

  ngOnInit(): void {
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$
      .pipe(filter((asset) => !this.commonUtilityLib.isEmptyObject(asset)))
      .subscribe((data) => {
        this.assetInfo = data;
      });
  }
  ngOnDestroy(): void {
    if (this.assetDataSubjectSubscription) this.assetDataSubjectSubscription.unsubscribe();
  }
}
